import { useTranslation } from 'react-i18next';

import { forwardRef, rem, StyleProps, Tooltip } from '@bonusly/design-system';

import { useActionInput } from '../../context';
import { TagButton } from './tag-button';

export type RecipientButtonProps = StyleProps;

export const RecipientButton = forwardRef<RecipientButtonProps, 'button'>((props, ref) => {
	const { t } = useTranslation('components', { keyPrefix: 'rich_media' });
	const { state } = useActionInput();
	const hasCustomGroupRecipient = state.recipients.some((recipient) => recipient.dimension === 'csv_upload');

	if (hasCustomGroupRecipient) {
		return (
			<Tooltip label={t('recipientTooltip')}>
				<TagButton tag="recipient" isDisabled p={{ base: rem(4), sm: 'auto' }} pr={{ base: rem(12), sm: 'auto' }} {...props} ref={ref} />
			</Tooltip>
		);
	}

	return <TagButton tag="recipient" p={{ base: rem(4), sm: 'auto' }} pr={{ base: rem(12), sm: 'auto' }} {...props} ref={ref} />;
});
